module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    class: _vm.$route.name.toLowerCase(),
    attrs: {
      "id": "app"
    }
  }, [(_vm.isLoaderShow) ? _c('app-header', {
    style: (_vm.loadingStyle)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "main",
    staticClass: "main-wrapper",
    style: (_vm.loadingStyle),
    attrs: {
      "id": "mainWrapper"
    }
  }, [_c('main', {
    staticClass: "main"
  }, [_c('transition', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    attrs: {
      "mode": "out-in",
      "css": false
    },
    on: {
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [_c('router-view', {
    ref: "page",
    attrs: {
      "mouse": _vm.mI,
      "mouseNoI": _vm.m,
      "scrollContent": _vm.scrollContent,
      "initObserver": _vm.initObserver,
      "is-desktop": _vm.isDesktop
    }
  })], 1)], 1)]), _vm._v(" "), _c('shapes', {
    ref: "$shapes",
    style: (_vm.loadingStyle),
    attrs: {
      "mouse": _vm.mI,
      "number": _vm.numberOfShapes,
      "is-dekstop": _vm.isDesktop,
      "is-visible": _vm.isShapesVisible
    }
  }), _vm._v(" "), _c('loader', {
    ref: "loader",
    attrs: {
      "isVisible": _vm.isLoading,
      "percentage": _vm.loaderProgress
    },
    on: {
      "shown": _vm.onLoaderShown,
      "hidden": _vm.onLoaderHidden
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b82f98b8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 179
// module chunks = 1